import { FC, useState } from 'react';
import { DashboardContextProvider } from './DashboardContext';
import { Header } from './layout/Header/Header';
import { Footer } from './layout/Footer';
import { Main } from './layout/Main';
import { Button, ButtonStyles, Popup } from '@silverfort/sf-components';
import { useHistory, useLocation } from 'react-router-dom';

const Dashboard: FC = () => {
    const location = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(location.search);
    const [showUpgradePopup, setShowUpgradePopup] = useState(params.get('upgradeCompleted') === 'true');

    return (
        <DashboardContextProvider>
            <div className="w-screen h-screen flex flex-col justify-center bg-sf-black pl-[64px]">
                <Header />
                <Main />
                <Footer />
            </div>
            {showUpgradePopup && (
                <Popup
                    FooterComponent={() => (
                        <Button
                            buttonStyle={ButtonStyles.PrimarySolid}
                            text="Close"
                            onClick={() => {
                                setShowUpgradePopup(false);
                                history.replace('/');
                            }}
                        />
                    )}
                    open={!!showUpgradePopup}
                    title="Upgrade Complete"
                    ContentComponent={() => (
                        <div>Your environment has been successfully upgraded to version {params.get('version')}.</div>
                    )}
                    onClose={() => {
                        setShowUpgradePopup(false);
                        history.replace('/');
                    }}
                />
            )}
        </DashboardContextProvider>
    );
};

export default Dashboard;
